import React from "react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// İnline stil tanımlamaları
const styles = {
  mainBanner: {
    position: "relative",
    width: "100%",
  },
  mySwiper: {
    width: "100%",
    height: "100%",
  },
  item: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "700px" /* Masaüstü için yükseklik */,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "0 50px",
  },
  // item1: {
  //   backgroundImage: "../../public/Assets/Images/banner-01.jpg",
  // },
  // item2: {
  //   backgroundImage: "../../public/Assets/Images/banner-02.jpg",
  // },
  // item3: {
  //   backgroundImage: "../../public/Assets/Images/banner-03.jpg",
  // },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.2)", // Resmin üzerine hafif siyah katman
    zIndex: 1,
  },
  headerText: {
    paddingLeft: "100px",
    position: "relative",
    zIndex: 2,
    maxWidth: "600px",
    minHeight: "200px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  locationBadge: {
    display: "inline-block",
    backgroundColor: "white",
    color: "#333",
    padding: "5px 15px",
    borderRadius: "4px",
    marginBottom: "25px",
    fontSize: "16px",
    fontWeight: "500",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    maxWidth: "fit-content",
  },
  locationHighlight: {
    color: "#4a86e8", // Mavi gibi bir vurgu rengi
    fontWeight: "500",
  },
  heading: {
    fontSize: "48px",
    fontWeight: "700",
    color: "white",
    lineHeight: "1.2",
    margin: "0",
    textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
    letterSpacing: "1px",
  },
  // Mobil cihazlar için medya sorguları
  "@media (max-width: 768px)": {
    item: {
      height: "500px", // Mobil için daha kısa yükseklik
      padding: "0 20px",
    },
    headerText: {
      paddingLeft: "20px", // Mobil için daha az padding
      maxWidth: "100%",
    },
    heading: {
      fontSize: "32px", // Mobil için daha küçük yazı tipi
    },
  },
  "@media (max-width: 480px)": {
    item: {
      height: "400px", // Daha küçük mobil cihazlar için daha da kısa yükseklik
    },
    heading: {
      fontSize: "28px", // Daha küçük mobil cihazlar için daha da küçük yazı tipi
    },
  },
};

const MainBanner = () => {
  // Ekran genişliğini kontrol eden hook
  const [windowSize, setWindowSize] = React.useState({
    width: undefined,
  });

  React.useEffect(() => {
    // Sayfa yüklendiğinde pencere boyutunu alır
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
      });
    }

    // Sayfa yüklendiğinde ilk boyutu al
    window.addEventListener("resize", handleResize);
    handleResize();

    // Temizleme işlevi
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Ekran boyutuna göre stil ayarları
  const isMobile = windowSize.width <= 768;
  const isSmallMobile = windowSize.width <= 480;

  const itemStyle = {
    ...styles.item,
    height: isSmallMobile ? "400px" : isMobile ? "500px" : "700px",
    padding: isMobile ? "0 20px" : "0 50px",
  };

  const headerTextStyle = {
    ...styles.headerText,
    paddingLeft: isMobile ? "20px" : "100px",
    maxWidth: isMobile ? "100%" : "600px",
  };

  const headingStyle = {
    ...styles.heading,
    fontSize: isSmallMobile ? "28px" : isMobile ? "32px" : "48px",
  };

  return (
    <div style={styles.mainBanner} className="main-banner">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={10}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        className="mySwiper"
        style={styles.mySwiper}
      >
        <SwiperSlide>
          <div
            style={{ ...itemStyle, ...styles.item1 }}
            className="item item-1"
          >
            <div style={styles.overlay}></div>
            <div style={headerTextStyle} className="header-text">
              <div style={styles.locationBadge}>
                Eskişehir, <span style={styles.locationHighlight}>Türkiye</span>
              </div>
              <h2 style={headingStyle}>
                RBA GAYRİMENKUL
                <br />
                BÜTÇENİZE
                <br />
                UYGUN EVİNİZİ
                <br />
                BULUN
              </h2>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            style={{ ...itemStyle, ...styles.item2 }}
            className="item item-2"
          >
            <div style={styles.overlay}></div>
            <div style={headerTextStyle} className="header-text">
              <div style={styles.locationBadge}>
                Eskişehir, <span style={styles.locationHighlight}>Türkiye</span>
              </div>
              <h2 style={headingStyle}>
                RBA GAYRİMENKUL
                <br />
                OLARAK
                <br />
                2 ŞUBEMİZLE
                <br />
                HİZMETİNİZDEYİZ
              </h2>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            style={{ ...itemStyle, ...styles.item3 }}
            className="item item-3"
          >
            <div style={styles.overlay}></div>
            <div style={headerTextStyle} className="header-text">
              <div style={styles.locationBadge}>
                Eskişehir, <span style={styles.locationHighlight}>Türkiye</span>
              </div>
              <h2 style={headingStyle}>
                RBA GAYRİMENKUL
                <br />
                ARSA, DÜKKAN
                <br />
                VE EV
                <br />
                SEÇENEKLERİ
              </h2>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default MainBanner;
